module.exports = __webpack_public_path__ + "static/media/planeacion.316be59f.jpg";